var map = {
	"./cc.jpg": "AOgg",
	"./dongfeng.jpg": "G1vG",
	"./faurecia.png": "vX8W",
	"./garrett.png": "jUSt",
	"./hbrdt.png": "BqhB",
	"./mahle.png": "j70Q",
	"./ofu.jpg": "9s3F",
	"./pangood.png": "09DG",
	"./plastic.png": "08tn",
	"./tenneco.png": "lCbN",
	"./tpi.png": "Co48",
	"./tpicomposites.png": "5dSH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kTaw";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companys ^\.\/.*$
// module id = kTaw
// module chunks = 0